import React from 'react';

import { usePermissions } from '@vyce/core/src/hooks/usePermissions';
import { INTERFACE_PERMISSIONS } from '@vyce/core/src/types';

import { GetStarted } from './components/GetStarted';

export const EmployerProjects: React.FC = () => {
  const { can } = usePermissions();

  // Projects sits under the Teams module in the permission catalogue — it has no
  // right of its own yet.
  return <GetStarted hasPermissions={can(INTERFACE_PERMISSIONS.TEAMS)} />;
};
